import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { hexToRgba } from '@/utils';

import ArrowUpIcon from '@/assets/icons/arrow-up.svg?react';

export const IconButton = styled(ArrowUpIcon)`
  position: absolute;
  fill: ${({ theme }) => theme.colors.light};
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  font-size: 24px;
  overflow: hidden;
  border: none;
  background: #000;
  transition: all 0.2s ease;

  /* need to style button and arrow on Safari (IOS) */
  &,
  &:enabled {
    color: #fff;
    cursor: pointer;
    border-radius: 50%;
    background: #000;
  }

  &:disabled {
    cursor: not-allowed;

    /* required to style an arrow on Safari (IOS) */
    background-color: #6c6c6c;

    ${IconButton} {
      fill: ${({ theme }) => hexToRgba(theme.colors.light, 0.6)};
    }
  }

  ${({ theme }) => css`
    ${theme.sendButton.styles}

    @media (${theme.mediaMobile}) {
      ${theme.sendButton.mobile}
    }

    @media not (${theme.mediaMobile}) {
      ${theme.sendButton.desktop}
    }
  `}

  ${({ theme }) => theme.sendButton};
`;
